import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import $ from "jquery"
import lodash from "lodash"

export default createReactClass({
  propTypes: {
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    showFullText: PropTypes.bool,
  },
  trim(raw, showFullText) {
    if (!raw) return "Untitled"
    var div = $("<div/>")

    var temp = div.html(
      raw
        .replace(/#\\/g, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/alert\(.*\)/g, "")
        .replace(/src\=.+?>/g, ">")
        .replace(/src\=.+?\s/g, " ")
        .replace("&nbsp;", " "),
    )
    temp.find("audio").replaceWith('<span class="text-italic">[audio]</span>')
    temp.find("img").replaceWith('<span class="text-italic">[image]</span>')
    temp.find("video").replaceWith('<span class="text-italic">[video]</span>')
    temp.find("a").replaceWith('<span class="text-italic">[link]</span>')
    temp.find("table").replaceWith('<span class="text-italic">[table]</span>')
    temp.find("div.locationmap").replaceWith('<span class="text-italic">[map]</span>')
    temp.find("div.embeddedContent").replaceWith('<span class="text-italic">[embedded]</span>')
    temp.find("script").replaceWith("")
    temp.find("br").replaceWith("")
    var text = temp
      .text()
      .replace(/(\r\n|\n|\r)/gm, "")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
    if (lodash.trim(text) == "")
      return $('<span class="text-italic">' + "<Untitled>" + "</span>").text()

    text = jQuery("<p>" + temp.text() + "</p>").text()
    return showFullText ? text : text.length > 200 ? text.slice(0, 200) + "..." : text
  },
  render() {
    return (
      <span className={this.props.className}>
        {this.trim(this.props.text, this.props.showFullText)}
      </span>
    )
  },
})
